import {
  Tooltip as MuiTooltip,
  PopperPlacementType,
  TooltipProps,
} from "@mui/material";
import React from "react";

export const Tooltip: React.FC<TooltipProps> = (props) => {
  const { children, ...rest } = props;

  const defaultTooltipProps = {
    arrow: true,
    placement: "top" as PopperPlacementType,
    enterDelay: 250,
    leaveDelay: 50,
    ...rest,
  };

  return (
    <MuiTooltip {...defaultTooltipProps} title={rest.title}>
      <div>{children}</div>
    </MuiTooltip>
  );
};
